import {
  IUnsubscribeGroup,
  CreateUnsubscribeGroupRequest,
  UpdateUnsubscribeGroupRequest,
  GetUnsubscribeGroupsResponse,
} from '../../types/unsubscribeGroups/unsubscribeGroups.types';
import {
  GET_UNSUBSCRIBE_GROUPS_REQUEST,
  GET_UNSUBSCRIBE_GROUPS_SUCCESS,
  GET_UNSUBSCRIBE_GROUPS_FAILURE,
  GET_UNSUBSCRIBE_GROUP_REQUEST,
  GET_UNSUBSCRIBE_GROUP_SUCCESS,
  GET_UNSUBSCRIBE_GROUP_FAILURE,
  CREATE_UNSUBSCRIBE_GROUP_REQUEST,
  CREATE_UNSUBSCRIBE_GROUP_SUCCESS,
  CREATE_UNSUBSCRIBE_GROUP_FAILURE,
  UPDATE_UNSUBSCRIBE_GROUP_REQUEST,
  UPDATE_UNSUBSCRIBE_GROUP_SUCCESS,
  UPDATE_UNSUBSCRIBE_GROUP_FAILURE,
  DELETE_UNSUBSCRIBE_GROUP_REQUEST,
  DELETE_UNSUBSCRIBE_GROUP_SUCCESS,
  DELETE_UNSUBSCRIBE_GROUP_FAILURE,
  GetUnsubscribeGroupsRequestAction,
  GetUnsubscribeGroupsSuccessAction,
  GetUnsubscribeGroupsFailureAction,
  GetUnsubscribeGroupRequestAction,
  GetUnsubscribeGroupSuccessAction,
  GetUnsubscribeGroupFailureAction,
  CreateUnsubscribeGroupRequestAction,
  CreateUnsubscribeGroupSuccessAction,
  CreateUnsubscribeGroupFailureAction,
  UpdateUnsubscribeGroupRequestAction,
  UpdateUnsubscribeGroupSuccessAction,
  UpdateUnsubscribeGroupFailureAction,
  DeleteUnsubscribeGroupRequestAction,
  DeleteUnsubscribeGroupSuccessAction,
  DeleteUnsubscribeGroupFailureAction,
  CLEAR_UNSUBSCRIBE_GROUP_STATE,
  ClearUnsubscribeGroupStateAction,
} from './unsubscribeGroups.types';

// Get Unsubscribe Groups Actions
export const getUnsubscribeGroupsRequest =
  (): GetUnsubscribeGroupsRequestAction => ({
    type: GET_UNSUBSCRIBE_GROUPS_REQUEST,
  });

export const getUnsubscribeGroupsSuccess = (
  response: GetUnsubscribeGroupsResponse
): GetUnsubscribeGroupsSuccessAction => ({
  type: GET_UNSUBSCRIBE_GROUPS_SUCCESS,
  payload: response,
});

export const getUnsubscribeGroupsFailure = (
  error: string
): GetUnsubscribeGroupsFailureAction => ({
  type: GET_UNSUBSCRIBE_GROUPS_FAILURE,
  payload: error,
});

// Get Unsubscribe Group Actions
export const getUnsubscribeGroupRequest = (
  id: string
): GetUnsubscribeGroupRequestAction => ({
  type: GET_UNSUBSCRIBE_GROUP_REQUEST,
  payload: id,
});

export const getUnsubscribeGroupSuccess = (
  unsubscribeGroup: IUnsubscribeGroup
): GetUnsubscribeGroupSuccessAction => ({
  type: GET_UNSUBSCRIBE_GROUP_SUCCESS,
  payload: unsubscribeGroup,
});

export const getUnsubscribeGroupFailure = (
  error: string
): GetUnsubscribeGroupFailureAction => ({
  type: GET_UNSUBSCRIBE_GROUP_FAILURE,
  payload: error,
});

// Create Unsubscribe Group Actions
export const createUnsubscribeGroupRequest = (
  unsubscribeGroupData: CreateUnsubscribeGroupRequest
): CreateUnsubscribeGroupRequestAction => ({
  type: CREATE_UNSUBSCRIBE_GROUP_REQUEST,
  payload: unsubscribeGroupData,
});

export const createUnsubscribeGroupSuccess = (
  unsubscribeGroup: IUnsubscribeGroup
): CreateUnsubscribeGroupSuccessAction => ({
  type: CREATE_UNSUBSCRIBE_GROUP_SUCCESS,
  payload: unsubscribeGroup,
});

export const createUnsubscribeGroupFailure = (
  error: string
): CreateUnsubscribeGroupFailureAction => ({
  type: CREATE_UNSUBSCRIBE_GROUP_FAILURE,
  payload: error,
});

// Update Unsubscribe Group Actions
export const updateUnsubscribeGroupRequest = (
  unsubscribeGroupData: UpdateUnsubscribeGroupRequest
): UpdateUnsubscribeGroupRequestAction => ({
  type: UPDATE_UNSUBSCRIBE_GROUP_REQUEST,
  payload: unsubscribeGroupData,
});

export const updateUnsubscribeGroupSuccess = (
  unsubscribeGroup: IUnsubscribeGroup
): UpdateUnsubscribeGroupSuccessAction => ({
  type: UPDATE_UNSUBSCRIBE_GROUP_SUCCESS,
  payload: unsubscribeGroup,
});

export const updateUnsubscribeGroupFailure = (
  error: string
): UpdateUnsubscribeGroupFailureAction => ({
  type: UPDATE_UNSUBSCRIBE_GROUP_FAILURE,
  payload: error,
});

// Delete Unsubscribe Group Actions
export const deleteUnsubscribeGroupRequest = (
  id: string
): DeleteUnsubscribeGroupRequestAction => ({
  type: DELETE_UNSUBSCRIBE_GROUP_REQUEST,
  payload: id,
});

export const deleteUnsubscribeGroupSuccess = (
  id: string
): DeleteUnsubscribeGroupSuccessAction => ({
  type: DELETE_UNSUBSCRIBE_GROUP_SUCCESS,
  payload: id,
});

export const deleteUnsubscribeGroupFailure = (
  error: string
): DeleteUnsubscribeGroupFailureAction => ({
  type: DELETE_UNSUBSCRIBE_GROUP_FAILURE,
  payload: error,
});

export const clearUnsubscribeGroupState =
  (): ClearUnsubscribeGroupStateAction => ({
    type: CLEAR_UNSUBSCRIBE_GROUP_STATE,
  });
